import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Icon } from 'components/common/Elements/Elements';

import classes from './BtnDel.module.scss';

const BtnDel = ({
  icon = 'Icn_Delete',
  onClick,
  className,
  classIcon,
  type = 'button'
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={cn(classes.btnDel, className)}
    >
      <Icon icon={icon} className={cn(classes.iconDelete, classIcon)} />
    </button>
  );
};

BtnDel.propTypes = {
  icon: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  classIcon: PropTypes.string,
  type: PropTypes.string
};

export default BtnDel;
